import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const IFrameWidgetRenderer = (props, context) => {
    const { sourceUrl, frameHeight, name, mode } = props;
    const { fiDomainInfo } = context;

    if (mode === 'ADMIN') {
        return <Fragment />;
    }

    let widgetUrl = sourceUrl;

    if (
        widgetUrl &&
        widgetUrl.indexOf('/') === 0 &&
        fiDomainInfo &&
        fiDomainInfo.origin
    ) {
        widgetUrl = `${fiDomainInfo.origin}${sourceUrl}`;
    }

    return (
        <iframe
            width="100%"
            height={frameHeight}
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-forms"
            src={widgetUrl}
            title={name}
        />
    );
};

IFrameWidgetRenderer.contextTypes = {
    fiDomainInfo: PropTypes.object,
};

IFrameWidgetRenderer.defaultProps = {
    frameHeight: 600,
};

IFrameWidgetRenderer.propTypes = {
    sourceUrl: PropTypes.string.isRequired,
    name: PropTypes.string,
    mode: PropTypes.string,
    frameHeight: PropTypes.number,
};

export default IFrameWidgetRenderer;
